<template>
  <div class="side-modal" @click="$emit('close', title)">
    <div class="side-modal__panel" @click.stop>
      <!-- Header -->
      <div class="side-modal__header">
        <div class="side-modal__header-left">
          <button
            v-if="showBackButton"
            class="side-modal__back-btn"
            @click="$emit('goBack', form)"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="side-modal__header-center">
          <h2 class="side-modal__title">{{ title }}</h2>
          <p v-if="subTitle" class="side-modal__subtitle" v-html="subTitle"></p>
        </div>
        <button class="side-modal__close-btn" @click="$emit('close', title)">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="side-modal__content">
        <slot name="content">content</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideModal",

  emits: ["close", "mounted", "goBack"],

  props: {
    title: { type: String, default: "", required: true },
    subTitle: { type: String, default: "" },
    form: { type: String, default: "" },
    showBackButton: { type: Boolean, default: true },
    bgChange: { type: Boolean, default: false },
  },

  mounted() {
    this.$emit("mounted", this.title);
    document.body.style.overflow = "hidden";
  },

  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$border-color: #E2E8F0;

.side-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  z-index: 50;
  display: flex;
  justify-content: flex-end;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  &__panel {
    width: 100%;
    max-width: 440px;
    height: 100vh;
    background: $bg-card;
    display: flex;
    flex-direction: column;
    animation: slideIn 0.3s ease;
    overflow: hidden;

    @keyframes slideIn {
      from { transform: translateX(100%); }
      to { transform: translateX(0); }
    }

    @media screen and (max-width: 480px) {
      max-width: 100%;
    }
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid $border-color;
    flex-shrink: 0;
  }

  &__header-left {
    width: 40px;
  }

  &__header-center {
    flex: 1;
    text-align: center;
    padding: 0 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: $text-primary;
    margin: 0;
  }

  &__subtitle {
    font-size: 13px;
    color: $text-muted;
    margin: 8px 0 0;
    line-height: 1.5;
  }

  &__back-btn,
  &__close-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: $text-secondary;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: $text-primary;
    }
  }

  &__content {
    flex: 1;
    overflow-y: auto;
    padding: 24px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: $border-color;
      border-radius: 3px;
    }
  }
}
</style>
